import type { ColorMode, DesignVariant } from '@/platform/theme/appearance';

export const COLOR_MODE_OPTIONS: { value: ColorMode; label: string }[] = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Hell' },
  { value: 'dark', label: 'Dunkel' },
];

export const VARIANT_OPTIONS: { value: DesignVariant; label: string; description: string }[] = [
  {
    value: 'brand',
    label: 'Marke',
    description: 'Navy und Rot. Das ist der Standard der Gebrüder Becker.',
  },
  {
    value: 'neutral',
    label: 'Neutral',
    description: 'Ruhiges Graphit mit einem kühlen Akzent, ohne das Marken-Navy auf jeder Fläche.',
  },
];
